/**
 * Forms used for adding or editing notes or assignments
 * Used by /dashboard and /dashboard/my-classes
 *
 */
e.D.note_assignment_forms = {

	note_form : {},
	assignment_form : {},

	init : function(){
		_.bindAll( this, '_handle_note_form', '_handle_assignment_form' );

		this.assignment_form = $( '#assignment-form' );
		if( this.assignment_form.length ){
			this.note_form = $( '#note-form' );
			this.note_form.find( 'input[type="submit"]' ).on( 'click', this._handle_note_form );

			this.assignment_form.find( 'input[type="submit"]' ).on( 'click', this._handle_assignment_form );
			
		}

		//my_classes passed by php @todo fix this
		if( typeof( my_classes ) != 'undefined' ){
			$( 'body' ).on( 'click', '.class-placeholder span', function(){
				e.D.note_assignment_forms._remove_class_placeholder( $( this ) );
			} );

			this._init_class_autocomplete();
		}

	},

	populate_edit_form : function( $edit_existing ){
		var $post = $( this );
		EdSpireAjax.Request( 'EdSpireMyClasses', 'editForm', $post.data( 'post' ), function( response ){
			var post = $.parseJSON( response );
			var $tab = form = {};
			if( post.post_type == 'note' ){
				$( '#new-note-tab' ).find( '> a' ).click();
				$tab = $( '#tabs-1' );
			} else {
				$( '#new-assignment-tab' ).find( '> a' ).click();
				$tab = $( '#tabs-2' );
				$tab.find( '.assignment-title' ).val( post.post_title );
				$tab.find( 'input[name="due_date"]' ).val( post.due_date );
			}
			$tab.find(  'textarea' ).html( post.post_content );
			form = $tab.find( 'form' );


			//post id
			form.find( 'input[name="post_id"]' ).remove();
			form.find( 'input[value="Publish"]' ).val( 'Update' );
			if( $edit_existing ){
				form.append( '<input type="hidden" name="post_id" value="' + post.ID + '" />' );
			}


			//schedule
			var scheduleWrap = form.find( '.schedule-wrap' );
			EdSpireDashboardObj.schedule.add( scheduleWrap, post.post_date );

			if( post.hide_due_date ){
				form.find( '[name="hide_due_date"]' ).prop( 'checked', true );
			} else{
				form.find( '[name="hide_due_date"]' ).prop( 'checked', false );
			}

			//classes
			var classWrap = form.find( '.assign-class' );
			classWrap.find( 'input[type="hidden"], .class-placeholder' ).remove();
			if( $edit_existing ){
				if( post.classes && post.classes.length != 0 ){
					for( var i = 0; i < post.classes.length; i++ ){
						data = {
							value : post.classes[i].ID,
							label : post.classes[i].post_title
						};
						e.D.note_assignment_forms._add_class_placeholder( classWrap, data );
					}
				}
			}

			//media
			var mediaWrap = form.find( '.media-wrap' );
			mediaWrap.html( '' );
			if( post.media && post.media.length != 0 ){
				for( var i = 0; i < post.media.length; i++ ){
					EdSpireDashboardObj.mediaUpload.add( mediaWrap, post.media[i].ID, post.media[i].post_title );
				}
			}

			//pdfs
			var pdfWrap = form.find( '.pdf-wrap' );
			pdfWrap.html( '' );
			if( post.pdfs && post.pdfs.length != 0 ){
				for( var i = 0; i < post.pdfs.length; i++ ){
					EdSpireDashboardObj.pdfUpload.add( pdfWrap, post.pdfs[i].ID, post.pdfs[i].post_title );
				}
			}

			//links
			var linksWrap = form.find( '.links-wrap' );
			linksWrap.html( '' );

			if( post.links && post.links.length != 0 ){
				for( var k in post.links ){
					EdSpireDashboardObj.addLink.add( linksWrap, k, post.links[k] );
				}
			}

			//folders
			var folderWrap = form.find( '.folders-wrap' );
			folderWrap.html( '' );
			if( post.folders && post.folders.length != 0 ){
				for( var i = 0; i < post.folders.length; i++ ){
					folder = post.folders[i];
					EdSpireDashboardObj.addFolder.add( folderWrap, folder.name, folder.term_id );
				}
			}

			e.el.doc.trigger( 'populate-edit-form-complete' );

			var offset = $( '#content' ).offset();
			$( 'html, body' ).animate( {
				scrollTop : offset.top
			} );
		} );
	},



	/**
	 * Reset the form errors and remove an error messages
	 *
	 * @param $form
	 * @private
	 */
	_reset_errors : function( $form ){
		$form.find( '.error' ).removeClass( 'error' );
		$form.find( '#message' ).remove();
	},


	/**
	 * Verify form data and display messages if fail
	 *
	 * @private
	 */
	_handle_note_form : function( ev ){
		ev.preventDefault();
		var $fail = false;
		var $message = '';
		var $form = this.note_form;
		this._reset_errors( $form );

		if( $form.find( '[name="assign-to-classes[]"]' ).length == 0 ){
			$form.find( '.classnames' ).addClass( 'error' );
			$fail = true;
			$message = config.errors.note_class;
		} else if( $form.find( '[name="post_content"]' ).val() == '' ){
			$form.find( '[name="post_content"]' ).addClass( 'error' );
			$fail = true;
			$message = config.errors.note_content;
		}

		if( $fail ){
			$template = Handlebars.compile( config.templates.error_message );
			$form.prepend( $template( { message : $message } ) );
		} else {
			$form.submit();
		}
	},


	/**
	 * Verify form data and display errors if fail
	 *
	 * @param ev
	 * @private
	 */
	_handle_assignment_form : function( ev ){
		ev.preventDefault();
		var $fail = false;
		var $message = '';
		var $form = this.assignment_form;
		this._reset_errors( $form );

		if( $form.find( '[name="assign-to-classes[]"]' ).length == 0 ){
			$form.find( '.classnames' ).addClass( 'error' );
			$fail = true;
			$message = config.errors.assignment_class;

		} else if ( $form.find( '[name="post_title"]' ).val() == '' ){
			$form.find( '[name="post_title"]' ).addClass( 'error' );
			$fail = true;
			$message = config.errors.assignment_title;

		} else if( $form.find( '[name="due_date"]' ).val() == '' && $form.find( '[name="hide_due_date"]' ).prop( 'checked' ) == false ){
			$form.find( '[name="due_date"]' ).addClass( 'error' );
			$fail = true;
			$message = config.errors.assignment_due_date;
		}

		if( $fail ){
			$template = Handlebars.compile( config.templates.error_message );
			$form.prepend( $template( { message : $message } ) );
		} else {
			$form.submit();
		}
	},


	_init_class_autocomplete : function(){

		$( '.classnames.autocomplete' ).autocomplete( {
			source : my_classes,  //set in the assign-class.php file
			focus : function( ev, ui ){
				ev.preventDefault();
				$(this ).val( ui.item.label );
			},
			select : function( ev, ui ){
				ev.preventDefault();
				$(this ).val( ui.item.label );
				var div = $( this ).parents( 'form' ).find( '.assign-class' );
				e.D.note_assignment_forms._add_class_placeholder( div, ui.item );
				$(this).val("");
			},
			messages : {
				noResults : config.i18n.no_class_matches,
				results : function( count ){
					return 'ee';
				}
			}
		} );
	},


	_remove_class_placeholder : function( el ){
		var div = el.parent();
		$( 'input[type="hidden"][value="' + div.data( 'class' ) + '"]' ).remove();
		div.remove();
	},


	_add_class_placeholder : function( e, item ){
		e.append( '<input type="hidden" name="assign-to-classes[]" value="' + item.value + '" />' );
		e.append( '<div class="class-placeholder" data-class="' + item.value + '">' + item.label + ' <span><i class="fa fa-times"></i></span></div>' );
		$( '.class-placeholder span' ).click( function(){
			var div = $( this ).parent();
			$( 'input[type="hidden"][value="' + div.data( 'class' ) + '"]' ).remove();
			div.remove();
		} );
	}

};